import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "m-8" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  key: 0,
  class: "mb-1 text-xl font-semibold"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "browse", -1)
const _hoisted_5 = {
  key: 1,
  class: "text-xl font-semibold"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "File must be BIN and up to 2MB", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isCreateModalOpened,
    "no-padding": true,
    onToggleModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          class: _normalizeClass(`flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 p-8 transition duration-500 ${
          _ctx.isDragging
            ? 'border-dashed border-primary '
            : 'border-dashed border-grey'
        }`),
          for: "file-upload",
          onDragover: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragOver && _ctx.handleDragOver(...args)), ["prevent"])),
          onDrop: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
          onDragleave: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)), ["prevent"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'file-code'],
            class: "mb-6 text-8xl text-primary"
          }),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.fileName === '')
              ? (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                  _createTextVNode(" Drag & Drop file here or "),
                  _hoisted_4
                ]))
              : (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.fileName), 1)),
            _hoisted_6
          ])
        ], 34),
        _createElementVNode("input", {
          id: "file-upload",
          accept: ".bin",
          class: "hidden",
          type: "file",
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFile && _ctx.handleFile(...args)))
        }, null, 32)
      ]),
      _createVNode(_component_the_button, {
        text: _ctx.$t('General.Upload'),
        size: "full",
        onExecuteMethod: _ctx.handleSubmit
      }, null, 8, ["text", "onExecuteMethod"])
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}